var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarOutline20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2a1 1 0 011 1h6a1 1 0 112 0 3 3 0 013 3v9a3 3 0 01-3 3H5a3 3 0 01-3-3V6a3 3 0 013-3 1 1 0 011-1zm7 3a1 1 0 102 0 1 1 0 011 1v2H4V6a1 1 0 011-1 1 1 0 002 0h6zm-9 5h12v5a1 1 0 01-1 1H5a1 1 0 01-1-1v-5z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02IDJDNi41NTIyOCAyIDcgMi40NDc3MiA3IDNIMTNDMTMgMi40NDc3MiAxMy40NDc3IDIgMTQgMkMxNC41NTIzIDIgMTUgMi40NDc3MiAxNSAzQzE2LjY1NjkgMyAxOCA0LjM0MzE1IDE4IDZWOVYxNUMxOCAxNi42NTY5IDE2LjY1NjkgMTggMTUgMThINUMzLjM0MzE1IDE4IDIgMTYuNjU2OSAyIDE1VjlWNkMyIDQuMzQzMTUgMy4zNDMxNSAzIDUgM0M1IDIuNDQ3NzIgNS40NDc3MiAyIDYgMlpNMTMgNUMxMyA1LjU1MjI4IDEzLjQ0NzcgNiAxNCA2QzE0LjU1MjMgNiAxNSA1LjU1MjI4IDE1IDVDMTUuNTUyMyA1IDE2IDUuNDQ3NzIgMTYgNlY4SDRWNkM0IDUuNDQ3NzIgNC40NDc3MiA1IDUgNUM1IDUuNTUyMjggNS40NDc3MiA2IDYgNkM2LjU1MjI4IDYgNyA1LjU1MjI4IDcgNUgxM1pNNCAxMEgxNlYxNUMxNiAxNS41NTIzIDE1LjU1MjMgMTYgMTUgMTZINUM0LjQ0NzcyIDE2IDQgMTUuNTUyMyA0IDE1VjEwWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgCalendarOutline20 as ReactComponent };